<ng-container *ngIf="subFolderItems()">
  <ng-container *ngIf="deviceType() === 'desktop'; else generalView">
    <li *ngFor="let page of subFolderItems(); let i = index">
      <ng-container *ngIf="page.type === 'folder'; else pageLink">
        <div class="sub-menu-folder">
          <div class="subfolders" [class]="'folders' + depth()">
            <custom-dot-cms-header-folder-index-page-check
              [navLink]="page"
              [dropDownLayer]="folderIndex()"
              [depth]="depth()"
              deviceType="desktop"
            />
            <div *ngIf="page?.children?.length > 0" class="folder-arrow"></div>
            <ng-container *ngIf="page?.children?.length > 0">
              <ul class="dotcms-submenu">
                <custom-dot-cms-sub-folder-header-navigation
                  [subFolderItems]="page.children"
                  [depth]="depth() + 1"
                  [folderIndex]="folderIndex()"
                  deviceType="desktop"
                />
              </ul>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <ng-template #pageLink>
        <a
          class="normallink"
          [routerLink]="dotCMSHeaderNavigationLink(page.href)"
          (click)="hideFlyout(folderIndex())"
          >{{ page.title }}</a
        >
      </ng-template>
    </li>
  </ng-container>
</ng-container>
<ng-template #generalView>
  <ul class="category-level{{ depth() }}" [ngClass]="{ 'dropdown-menu': depth() === 1 }">
    <li
      *ngFor="let folderItem of subFolderItems()"
      class="main-navigation-level1-item"
      [ngClass]="{ open: isOpened(folderItem) }"
    >
      <ng-container *ngIf="folderItem.type === 'folder'; else pageLink">
        <ng-container *ngIf="folderItem.children; else noPage">
          <ng-container *ngIf="isHavingIndexPage(folderItem); else noPage">
            <a class="font-weight-bold" [routerLink]="dotCMSHeaderNavigationLink(folderItem.href)">
              {{ folderItem.title }}
            </a>
          </ng-container>
        </ng-container>
        <ng-template #noPage>
          <div class="mob-disable-links font-weight-bold">{{ folderItem.title }}</div>
        </ng-template>
        <ng-container *ngIf="folderItem?.children?.length > 0">
          <a
            [routerLink]="[]"
            (click)="toggleOpen(folderItem)"
            [attr.aria-label]="isOpened(folderItem) ? 'collapse ' + folderItem.title : 'expand ' + folderItem.title"
            [ngClass]="{ 'd-none': view() === 'full' }"
            class="dropdown-toggle"
          >
            <fa-icon *ngIf="isOpened(folderItem); else closed" [icon]="['fas', 'minus']" />
            <ng-template #closed> <fa-icon [icon]="['fas', 'plus']" /> </ng-template>
          </a>
        </ng-container>
        <!--If sub-folder have folder and pages same  subFolderHeaderNavigation component is called again-->
        <custom-dot-cms-sub-folder-header-navigation [subFolderItems]="folderItem.children" [depth]="depth() + 1" />
      </ng-container>
      <ng-template #pageLink>
        <a class="normal-link font-weight-normal" [routerLink]="dotCMSHeaderNavigationLink(folderItem.href)">{{
          folderItem.title
        }}</a>
      </ng-template>
    </li>
  </ul>
</ng-template>
